<template>
  <el-dialog
      size="small"
      :title="action === 'edit' ? $t('text.edit') : $t('text.add')"
      :visible="show"
      @close="closeDialog"
      @open="init"
      :close-on-click-modal="false"
      width="680px"
  >
    <el-form size="small" :model="form2" :rules="rules" ref="form2">
      <el-form-item
          size="small"
          :label="$t('text.cardType')"
          :label-width="formLabelWidth"
      >
        <el-select size="small" v-model="form2.cardType" :placeholder="$t('message.chooseOne')">
          <el-option
              size="small"
              v-for="item in cardTypeList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
          size="small"
          :label="$t('text.accountNumber')"
          :label-width="formLabelWidth"
          prop="receiverCardAccount"
      >
        <el-input
            size="small"
            v-model="form2.receiverCardAccount"
            autocomplete="off"
            :placeholder="$t('message.inputUpstream')"
        ></el-input>
      </el-form-item>
      <el-form-item
          size="small"
          :label="$t('text.cardholderName')"
          :label-width="formLabelWidth"
          prop="receiverName"
      >
        <el-input
            size="small"
            v-model="form2.receiverName"
            autocomplete="off"
            :placeholder="$t('message.inputUpstream')"
        ></el-input>
      </el-form-item>
      <el-form-item
          size="small"
          :label="$t('text.minAmount')"
          :label-width="formLabelWidth"
          prop="minAmount"
      >
        <el-input
            size="small"
            v-model="form2.minAmount"
            autocomplete="off"
            :placeholder="$t('message.minAmountRequired')"
        ></el-input>
      </el-form-item>
      <el-form-item
          size="small"
          :label="$t('text.maxAmount')"
          :label-width="formLabelWidth"
          prop="maxAmount"
      >
        <el-input
            size="small"
            v-model="form2.maxAmount"
            autocomplete="off"
            :placeholder="$t('message.maxAmountRequired')"
        ></el-input>
      </el-form-item>
      <el-form-item
          size="small"
          :label="$t('text.cardLimit')"
          :label-width="formLabelWidth"
          prop="formLabelWidth"
      >
        <div v-for="(item, index) in form2.quotaList" :key="index"
             style="margin-bottom: 10px; display: flex; align-items: center;">
          <div v-if="quotaListCount">
            <el-select
                size="small"
                v-model="item.quotaType"
                filterable
                :placeholder="$t('message.typeRequiredError')"
                style="width: 90px;"
            >
              <el-option
                  size="small"
                  v-for="option in quotaName"
                  :key="option.quotaType"
                  :label="option.label"
                  :value="option.quotaType"
              />
            </el-select>
            <el-input
                size="small"
                v-model="item.quotaValue"
                autocomplete="off"
                style="width: 370px; margin-left: 10px; margin-right: 10px;"
                :placeholder="$t('message.inputMinTransactionAmount')"
            ></el-input>

            <el-button size="small" type="primary" @click="addQuotaListAmount"
                       style="width: 46px;height: 32px;padding-top: 9px;padding-right: 16px;padding-bottom: 9px;padding-left: 16px;gap: 8px;border-radius: 2px;"
            >
              <span style="display: inline-block; width: 14px; height: 14px; font-size: 14px; text-align: center; line-height: 14px;">{{ '＋' }}</span>
            </el-button>
          </div>
          <div v-else-if="!quotaListCount">
            <el-select
                size="small"
                v-model="item.quotaType"
                filterable
                style="width: 90px"
                :disabled="isDisabled"
            >
              <el-option
                  size="small"
                  v-for="item in availableOptions"
                  :key="item.label"
                  :label="item.label"
                  :value="item.quotaType"
              />
            </el-select>
            <el-input
                size="small"
                v-model="item.quotaValue"
                autocomplete="off"
                style="width: 318px; margin-left: 10px; margin-right: 10px;"
                :placeholder="$t('message.inputMinTransactionAmount')"
            ></el-input>
            <el-button size="small"
                       type="danger"
                       @click="removeQuotaListAmount(index)"
                       style="width: 46px;height: 32px;padding-top: 9px;padding-right: 16px;padding-bottom: 9px;padding-left: 16px;gap: 8px;border-radius: 2px;"
            >
              <span style="display: inline-block; width: 14px; height: 14px; font-size: 14px; text-align: center; line-height: 14px;">{{ 'X' }}</span>
            </el-button>
            <el-button size="small" type="primary" @click="addQuotaListAmount"  :disabled="canAddQuota"
                       style="width: 46px;height: 32px;padding-top: 9px;padding-right: 16px;padding-bottom: 9px;padding-left: 16px;gap: 8px;border-radius: 2px;"
            >
              <span style="display: inline-block; width: 14px; height: 14px; font-size: 14px; text-align: center; line-height: 14px;">{{ '＋' }}</span>
            </el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item size="small" :label="$t('text.upstreamAbridge')" :label-width="formLabelWidth">
        <el-select size="small" v-model="form2.receiverCardOrganization" :placeholder="$t('message.chooseOne')">
          <el-option
              size="small"
              v-for="item in cardUpstreamList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item size="small" :label="$t('text.deviceId')" :label-width="formLabelWidth" prop="deviceId">
        <el-input size="small" v-model="form2.deviceId" autocomplete="off" :placeholder="$t('message.deviceIdRequired')"></el-input>
      </el-form-item>
      <el-form-item
          size="small"
          :label="$t('text.status')"
          :label-width="formLabelWidth"
          prop="alarmThresholdDay"
      >
        <el-radio-group size="small" v-model="form2.status">
          <el-radio size="small" label="01">{{ $t('cardStatus.01') }}</el-radio>
          <el-radio size="small" label="00">{{ $t('cardStatus.00') }}</el-radio>
          <el-radio size="small" label="02">{{ $t('cardStatus.02') }}</el-radio>
          <el-radio size="small" label="03" v-if ="statusValue === '03'"> {{ $t('cardStatus.03') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
          size="small"
          :label="$t('text.useWeight')"
          :label-width="formLabelWidth"
      >
        <div class="slider-demo-block">
          <el-slider size="small" v-model="form2.priority"/>
        </div>
      </el-form-item>
      <el-form-item size="small" :label="$t('text.remark')" prop="remark" :label-width="formLabelWidth">
        <el-input size="small" type="textarea" :placeholder="$t('message.inputRemark')" v-model="form2.remark"/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button size="small" type="primary" @click="saveSystem" v-if="isButton">
        {{ $t('text.confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  PAYMENT_TYPE_ID_COLLECTION,
  PAYMENT_TYPE_ID_PAYMENT
} from "@/utils/Constant";

import vueJsonEditor from 'vue-json-editor';

export default {
  name: "channelEdit",
  props: {
    show: Boolean,
    value: Object,
    action: String,
    channelOption: Array,
    cardTypeList: {
      type: Array,
      required: true
    },
    cardUpstreamList: {
      type: Array,
      required: true
    },
  },
  components: {
    vueJsonEditor,
  },
  data() {
    return {
      PAYMENT_TYPE_ID_COLLECTION,
      PAYMENT_TYPE_ID_PAYMENT,
      dialogShow: this.show,
      groups: "",
      statusValue: "",
      isButton: true,
      isDisabled: false,
      time: {start: "00:00", step: "00:05", end: "23:59"},
      form2: {
        receiverCardAccount: "",
        receiverCardOrganization: "",
        status: "01",
        minAmount: "100",
        maxAmount: "50000",
        dailyQuota: "",
        weekQuota: "",
        monthQuota: "",
        yearQuota: "",
        deviceId: "",
        priority: 50,
        quotaList: [{quotaType: this.$t('quota.daily'), quotaValue: '100'}],
      },
      alarmThresholdDay: this.$t('status.normal'),
      quotaName: [
        {quotaType: 'monthQuota', label: this.$t('quota.monthly')},
        {quotaType: 'dailyQuota', label: this.$t('quota.daily')}
      ],
      selectedQuota: '', // 当前选中的值
      formLabelWidth: "110px",
      rules: {
        receiverCardAccount: [
          {required: true, message: this.$t('message.receiverCardAccountRequired'), trigger: 'blur'},
          {min: 10, max: 20, message: this.$t('message.accountLength'), trigger: 'blur'}
        ],
        cardType: [
          {required: true, message: this.$t('message.cardTypeRequired'), trigger: 'change'}
        ],
        receiverName: [
          {required: true, message: this.$t('message.receiverNameRequired'), trigger: 'blur'},
          {type: 'string', min: 2, message: this.$t('message.nameTooShort'), trigger: 'blur'}
        ],
        minAmount: [
          {required: true, message: this.$t('message.minAmountRequired'), trigger: 'blur'},
        ],
        maxAmount: [
          {required: true, message: this.$t('message.maxAmountRequired'), trigger: 'blur'},
        ],
        receiverCardOrganization: [
          {required: true, message: this.$t('message.organizationRequired'), trigger: 'change'}
        ],
        priority: [
          {required: true, message: this.$t('message.priorityRequired'), trigger: 'change'},
          {type: 'number', min: 0, max: 100, message: this.$t('message.priorityRange'), trigger: 'change'}
        ],
        remark: [
          {max: 200, message: this.$t('message.remarkTooLong'), trigger: 'blur'}
        ],
        deviceId: [
          {required: true, message: this.$t('message.deviceIdRequired'), trigger: 'blur'},
          {min: 2, message: this.$t('message.deviceIdTooShort'), trigger: 'blur'}
        ]
      }
    };
  },
  created() {
    if (this.action === "edit") {
      this.form2 = Object.assign({}, this.value);
      this.form2.createTime = '';
      this.statusValue = this.form2.status;
    }
  },
  methods: {
    addQuotaListAmount() {
      if (this.canAddQuota) {
        this.form2.quotaList.push({
          quotaType: '',
          quotaValue: ''
        });
      }
    },
    removeQuotaListAmount(index) {
      this.form2.quotaList.splice(index, 1);
    },
    init() {
        console.log('this.value');
        console.log(this.value);
      if (this.action === "edit") {
        this.form2 = Object.assign({}, this.value);
      }
    },
    closeDialog() {
      this.form2 = {
        receiverCardAccount: "",
        receiverCardOrganization: "",
        status: "00",
        upstream: "",
        minAmount: "100",
        maxAmount: "50000",
        dailyQuota: "",
        weekQuota: "",
        monthQuota: "",
        yearQuota: "",
        deviceId: "",
        cardUpstream: "",
        priority: 50,
        alarmBalanceThreshold: "0",
        // groupId: "0",
        quotaList: [{quotaType: '每日', quotaValue: '100'}],
      };
      this.statusValue = "";
      // this.$refs["form2"].resetFields(); //关闭的时候重置表单
      this.$emit("update:show", false);
    },
    saveSystem() {
      if (this.form2.quotaList && Array.isArray(this.form2.quotaList)) {
        this.form2.quotaList.forEach(item => {
          if (item.quotaType === "yearQuota") {
            this.form2.yearQuota = item.quotaValue;
          }
          if (item.quotaType === "monthQuota") {
            this.form2.monthQuota = item.quotaValue;
          }
          if (item.quotaType === "weekQuota") {
            this.form2.weekQuota = item.quotaValue;
          }
          if (item.quotaType === "每日" || item.quotaType === "dailyQuota") {
            this.form2.dailyQuota = item.quotaValue;
          }
        })
      }
      this.form2.quotaList = [];
      this.$refs["form2"].validate((valid) => {
        if (valid) {
          if (this.action === "edit") {
            this.axios.put("/card/updateCard", this.form2).then((res) => {
              if (res.code === 200) {
                this.$notify({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                  type: "success"
                });
                this.$bus.$emit("refresh"); //通知刷新

                this.closeDialog();
                this.$emit('refresh-upstream-list');
                this.$emit('refresh-card-list');
              } else {
                this.$notify.error({
                  title: this.$t('text.prompt'),
                  message: res.msg
                });
              }
            });
          } else {
            this.axios.post("/card/addCard", this.form2).then((res) => {
              if (res.code === 200) {
                this.$notify({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                  type: "success"
                });
                this.$bus.$emit("refresh"); //通知刷新
                this.$emit('refresh-card-list');
                this.closeDialog();
                this.$emit('refresh-upstream-list');
              } else {
                this.$notify.error({
                  title: this.$t('text.prompt'),
                  message: res.msg
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    }
    ,
  },
  mounted() {

    if (this.cardUpstreamList.length > 0 && !this.form2.receiverCardOrganization) {
      this.form2.receiverCardOrganization = this.cardUpstreamList[0].value;
    }

    if (this.cardTypeList.length > 0 && !this.form2.cardType) {
      this.form2.cardType = this.cardTypeList[0].value;
    }

    this.$bus.$on("refreshButton", (isButton) => {
      this.isButton = isButton;
    });
    this.$bus.$on("isDisabled", (isDisabled) => {
      this.isDisabled = isDisabled;
    });
    this.$bus.$on("dialogShow", (dialogShow) => {
      this.dialogShow = dialogShow;
    });

  },
  computed: {
    availableOptions(currentIndex) {
      // return this.quotaName.filter(option => {
      //   return !this.form2.quotaList.some((item, index) =>
      //       index !== currentIndex && item.quotaType === option.quotaType
      //   );
      // });
      return this.quotaName;
    },
    canAddQuota() {
      return this.availableOptions.length > 0;
    },
    quotaListCount() {
      return this.form2.quotaList.length <= 1;
    },
  },
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>
